//
//
//
//
//
//
//
//

export default {
  name: 'Trail',
  props: ['session', 'config'],
  methods: {
    stepClass(step) {
      if (step.step === this.session.step) {
        return 'is-active'
      } else if (step.step === this.session.step - 1) {
        return 'is-most-recent'
      } else if (step.step < this.session.step) {
        return 'is-complete'
      }
    },
    goToStep(step) {},
  },
}
